import Box from './Box';
import React from 'react';
import Text from './Text';
import './FormFieldGroup.css';

interface FormFieldGroupOptions {
  label?: any;
  children: JSX.Element[] | JSX.Element
  marginLeft?: number;
  width?: string;
  marginVertical?: number;
}

function FormFieldGroup({ children, marginLeft, width, marginVertical = 16, label }: FormFieldGroupOptions) {
  return (
    <Box marginVertical={marginVertical} className='FormFieldGroup' marginLeft={marginLeft} style={{ maxWidth: width }}>
      {
        label &&
        <Box paddingBottom={0}>
          <Text size={13} weight='500' color='black'>{label}</Text>
        </Box>
      }
      {children}
    </Box>
  );
}

export default FormFieldGroup;